import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SalesReportsContent from '../SalesReportsContent';
import {
    setFromDate,
    setToDate,
    setSelectedBranch,
    applyFilters,
    fetchSalesReportData
} from '../../../store/slices/salesReportsSlice';

const SalesReports = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        // Manager view has no filter bar/Apply button of its own, so nothing else would ever
        // snapshot fromDate/toDate/selectedBranch into applied*— and Branch Analysis/Cashier
        // Sales/Session Sales all fetch off the applied* values, not the live ones, so without
        // this they'd never load for a Manager no matter what.
        dispatch(applyFilters());
        dispatch(fetchSalesReportData({
            fromDate: today,
            toDate: today,
            branchId: storedBranchId
        }));
    }, [dispatch, storedBranchId, storedBranchName]);

    return <SalesReportsContent isManagerView />;
};

export default SalesReports;
